<template>
  <div class="search-line">
    <slot name="openParen"></slot>
    <el-select v-model="prop" :placeholder="$t('message.placeholder.selectAttribute')" size="small" clearable
      class="colum" @change="getProp">
      <el-option v-for="item in pageInfo" :key="item.value" :label="item.label" :value="item.value">
      </el-option>
    </el-select>

    <el-select v-model="operator" :placeholder="$t('message.placeholder.selectOperator')" size="small" clearable
      class="colum" @change="toSearch">
      <el-option-group v-for="group in operatorList" :key="group.label" :label="group.label">
        <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-option-group>
    </el-select>

    <Val :getList="list" :propData="toVal" :operatorType="operator" :values="values" :loadedSearch="loadedSearch"
      class="colum-input" @change="inputVal"></Val>

    <slot name="closeParen"></slot>
    <el-select v-model="link" :placeholder="$t('message.placeholder.select')" size="small" class="colum-link"
      @change="toSearch" v-if="oneSearchItem != true">
      <el-option v-for="item in logical" :key="item.value" :label="item.label" :value="item.value">
      </el-option>
    </el-select>
  </div>
</template>

<script>
import axios from "axios";
import Val from "../searchItem/val.vue";
import { OPERATOR_GROUP, OPERATOR_LIST, SPECIAL_LIST } from "../constant";
export default {
  data() {
    return {
      idList: [],
      operatorGroup: [...OPERATOR_GROUP()],
      toVal: "",
      values: "", //criteria中，每一个条件中的值
      col: {},
      speList: [...SPECIAL_LIST],

      logical: [
        { label: this.$t("message.operatorGroup.and"), value: 1 },
        { label: this.$t("message.operatorGroup.or"), value: 2 },
      ],

      pageInfo: [],

      openParen: "",
      closeParen: "",

      operatorList: [],
      list: [],
      prop: "",
      operator: "",
      link: 1,
      value: "",

      nlistId: ''
    };
  },
  props: ["getAttr", "criteriaInfo", "loadedSearch", "oneSearchItem"],
  components: {
    Val,
  },
  methods: {
    getProp(e) {
      // this.toVal = e
      // this.values = "";
      this.operator = "";
      if (e == "") {
        this.operatorList = [];
        console.log(e);
        this.prop = "";
        this.operator = "";
        this.link = 1;
        this.value = "";
        this.toSearch();
        return;
      }
      // m：获取prop各属性值
      let m = this.pageInfo.find((i) => i.value == e)
      console.log(m);
      this.toVal = [e, m.uiType];

      if (m.uiType == 3 || m.uiType == 4) {
        this.nlistId = m.listId
      }

      //  运算符分组确定
      // console.log(m.uiType);
      // if (e == this.Constants.projectP1Root || e == this.Constants.projectP1Parent || e == this.Constants.projectP1Status || e == this.Constants.projectP1CreateFromTemplate) {
      //   console.log(e);
      const { projectP1Root, projectP1Parent, projectP1Status, projectP1CreateFromTemplate } = this.Constants;
      const arr = [projectP1Root, projectP1Parent, projectP1Status, projectP1CreateFromTemplate];
      if (arr.includes(e)) {
        this.operatorList = [...OPERATOR_LIST()]
      } else {
        this.operatorList = this.operatorGroup.filter((i) => {
          return i.uiType.includes(m.uiType);
        });
      }

      // console.log(this.operatorList);
      const item = this.getAttr[1].find(i => i.value === e);

      //  获取特殊列表值,生命周期、类型、创建者
      if (this.speList.includes(e) || item.listType === 3) {
        // console.log(11111111111111111);
        let obj = {
          attrId: e,
          baseId: this.idList.baseId,
          classId: this.idList.classId,
          subClassId: this.idList.subClassId,
          listId: item.listId
        };
        axios
          .get(`/search/advanced/getListEntryForSearch${this.params(obj)}`)
          .then((res) => {
            console.log(res);
            this.list = res.data.object.entryList.map((i) => {
              return { label: i.entryValue, value: i.entryId + '' };
            });
            // console.log(this.list);
          });
        return;
      }
      //无lsitID
      if (m.listId == -1) {
        this.list = [];
        return;
      }
      //获取uiType列表值
      let _obj = {};
      for (let i = 0; i < this.col.listEntries.length; i++) {
        const ele = this.col.listEntries[i];
        // console.log(ele);
        _obj = Object.assign(_obj, ele);
      }
      this.list = Object.values(_obj[m.listId]).map((i, j) => {
        // return { value: parseInt(j + 1), label: i };
        return { value: Object.keys(_obj[m.listId])[j] + '', label: i };
      });
      // console.log(this.list);
      this.toSearch();
    },
    inputVal(e) {
      this.value = e;
      this.toSearch();
    },
    // pushData(e) {
    // },
    // logic(e){
    //   this.link = e
    // },
    toSearch() {
      let pageData = {
        attrId: this.prop,
        relationalOp: this.operator,
        logicalOp: this.link,
      };
      console.log(this.nlistId);
      (!!this.nlistId) && Object.assign(pageData, { listId: this.nlistId })
      Object.assign(pageData, this.value);
      console.log(pageData);
      // this.$emit("getPageData", pageData);
      this.$emit("update:change", pageData);
    },
  },
  watch: {
    getAttr(n) {
      // console.log(n);
      this.prop = "";
      this.operator = "";
      this.pageInfo = n[1];
      this.col = n[0];
      this.idList = n[2];
      // console.log(this.loadedSearch);
      //加载从个人搜索保存的search
      if (this.loadedSearch) {
        this.prop = this.criteriaInfo.attrId;
        // console.log(this.prop);
        if (this.prop == undefined) {
          // console.log(this.prop);
          return true;
        }
        this.getProp(this.prop);
        this.operator = this.criteriaInfo.relationalOp;
        this.toSearch();
        this.link = this.criteriaInfo.logicalOp;
        // console.log(this.operator);
        // this.values = [this.criteriaInfo.value, this.criteriaInfo.secValue];
        if (this.operator == 16 || this.operator == 17) {
          //between的values要包含两个值
          this.values = [this.criteriaInfo.value, this.criteriaInfo.secValue];
        } else {
          this.values = this.criteriaInfo.value;
        }

        // console.log(this.values);
      }
    },
    // getCriteria(criteriaInfo){
    //   console.log(criteriaInfo);
    // },
  },
  created() { },
};
</script>

<style scoped>
.search-line {
  margin: 15px 0 0 10px;
  width: 1200px;
  overflow: hidden;
}

.colum {
  margin-left: 5px;
  width: 15%;
}

.colum-input {
  margin-left: 5px;
  width: 28%;
}

.colum-link {
  width: 10%;
  margin-left: 5px;
}
</style>
